import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, MapPin, Phone, Mail, Clock } from "lucide-react";
import { SCHOOL, LOGO, NAV_LINKS, MORE_LINKS } from "@/lib/constants";

export const Footer = () => (
  <footer className="bg-navy text-slate-300">
    <div className="max-w-7xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <img src={LOGO} alt="logo" className="h-14 w-14 object-contain bg-white rounded-full p-1" />
          <div>
            <div className="font-head font-extrabold text-white text-lg">B.R.Smart Academy</div>
            <div className="text-xs text-gold">{SCHOOL.tagline}</div>
          </div>
        </div>
        <p className="text-sm leading-relaxed text-slate-400">
          A CBSE English medium school nurturing bright futures since {SCHOOL.estYear}. Proudly supported by {SCHOOL.foundation} (est. {SCHOOL.foundationYear}).
        </p>
        <div className="flex gap-3 mt-5">
          <a href={SCHOOL.social.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="h-9 w-9 grid place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-navy transition-colors"><Facebook className="h-4 w-4" /></a>
          <a href={SCHOOL.social.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="h-9 w-9 grid place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-navy transition-colors"><Instagram className="h-4 w-4" /></a>
          <a href={SCHOOL.social.youtube} target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" className="h-9 w-9 grid place-items-center rounded-full bg-white/10 hover:bg-gold hover:text-navy transition-colors"><Youtube className="h-4 w-4" /></a>
        </div>
      </div>

      <div>
        <h4 className="font-head font-bold text-white mb-4">Quick Links</h4>
        <ul className="space-y-2 text-sm">
          {[...NAV_LINKS, ...MORE_LINKS].map((l) => (
            <li key={l.path}>
              <Link to={l.path} className="hover:text-gold transition-colors">{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-head font-bold text-white mb-4">Contact</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex gap-2"><MapPin className="h-4 w-4 text-gold shrink-0 mt-0.5" /> {SCHOOL.address}</li>
          <li className="flex gap-2"><Phone className="h-4 w-4 text-gold shrink-0 mt-0.5" /> {SCHOOL.landline} <br />{SCHOOL.phones.join(" / ")}</li>
          <li className="flex gap-2"><Mail className="h-4 w-4 text-gold shrink-0 mt-0.5" /> {SCHOOL.email}</li>
        </ul>
      </div>

      <div>
        <h4 className="font-head font-bold text-white mb-4">Timings</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex gap-2"><Clock className="h-4 w-4 text-gold shrink-0 mt-0.5" /> <span><b className="text-white">School:</b> {SCHOOL.schoolTiming}</span></li>
          <li className="flex gap-2"><Clock className="h-4 w-4 text-gold shrink-0 mt-0.5" /> <span><b className="text-white">Office:</b> {SCHOOL.officeTiming}</span></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
        <p>© {new Date().getFullYear()} B.R.Smart Kidz / Academy. All rights reserved.</p>
        <div className="flex gap-4">
          <Link to="/privacy" className="hover:text-gold" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-gold" data-testid="footer-terms">Terms & Conditions</Link>
        </div>
      </div>
    </div>
  </footer>
);
